import type { Struct, StructError } from "superstruct";
import { validate } from "superstruct";

export async function decodeResponse<T>(
  response: Response,
  struct: Struct<T>,
): Promise<[StructError | undefined, T | undefined]> {
  const json: unknown = await response.json();

  const [err, decodedResponse] = validate(json, struct);

  if (err && process.env.NODE_ENV === "development") {
    throw err;
  }

  return [err, decodedResponse];
}
